module.exports = __webpack_public_path__ + "translations/en/errors.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/errors.json
// module id = ./translations/en/errors.json
// module chunks = 1